import { useState } from 'react';
import { X, Sliders, Check } from 'lucide-react';

export function EZ5050IndicatorsModal({ config, onUpdate, onClose }) {
  const [local, setLocal] = useState({ ...config });

  const handleSave = () => {
    onUpdate && onUpdate(local);
    onClose && onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-4"
      style={{ background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)' }}>
      <div className="w-full max-w-md overflow-hidden shadow-2xl rounded-2xl"
        style={{ background: '#121824', border: '1px solid #232f45' }}>
        {/* Header */}
        <div className="p-4 flex justify-between items-center"
          style={{ background: '#0f141e', borderBottom: '1px solid #1f2a3e' }}>
          <div className="flex items-center space-x-2">
            <Sliders className="w-5 h-5" style={{ color: '#fbbf24' }} />
            <h3 className="font-bold text-white text-base">Technical Indicators</h3>
          </div>
          <button onClick={onClose} className="p-1 rounded-lg" style={{ color: '#94a3b8' }}>
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5 space-y-5 max-h-[70vh] overflow-y-auto ez-trading-scroll">
          {/* MA 1 */}
          <div className="p-3.5 rounded-xl space-y-3"
            style={{ background: '#172030', border: '1px solid #222f47' }}>
            <div className="flex items-center justify-between">
              <label className="flex items-center space-x-2 cursor-pointer">
                <input type="checkbox" checked={local.ma1Active}
                  onChange={(e) => setLocal({ ...local, ma1Active: e.target.checked })}
                  className="w-4 h-4 rounded" />
                <span className="font-bold text-sm" style={{ color: '#e2e8f0' }}>Moving Average 1 (MA 1)</span>
              </label>
              <input type="color" value={local.ma1Color || '#818cf8'}
                onChange={(e) => setLocal({ ...local, ma1Color: e.target.value })}
                className="w-6 h-6 rounded cursor-pointer border-0 bg-transparent" />
            </div>
            {local.ma1Active && (
              <div className="flex items-center justify-between text-xs" style={{ color: '#cbd5e1' }}>
                <span>Period:</span>
                <input type="number" min={2} max={200} value={local.ma1Period}
                  onChange={(e) => setLocal({ ...local, ma1Period: Number(e.target.value) })}
                  className="w-20 rounded px-2 py-1 text-center font-bold text-white"
                  style={{ background: '#0f1522', border: '1px solid #283652' }} />
              </div>
            )}
          </div>

          {/* MA 2 */}
          <div className="p-3.5 rounded-xl space-y-3"
            style={{ background: '#172030', border: '1px solid #222f47' }}>
            <div className="flex items-center justify-between">
              <label className="flex items-center space-x-2 cursor-pointer">
                <input type="checkbox" checked={local.ma2Active}
                  onChange={(e) => setLocal({ ...local, ma2Active: e.target.checked })}
                  className="w-4 h-4 rounded" />
                <span className="font-bold text-sm" style={{ color: '#e2e8f0' }}>Moving Average 2 (MA 2)</span>
              </label>
              <input type="color" value={local.ma2Color || '#f59e0b'}
                onChange={(e) => setLocal({ ...local, ma2Color: e.target.value })}
                className="w-6 h-6 rounded cursor-pointer border-0 bg-transparent" />
            </div>
            {local.ma2Active && (
              <div className="flex items-center justify-between text-xs" style={{ color: '#cbd5e1' }}>
                <span>Period:</span>
                <input type="number" min={2} max={200} value={local.ma2Period}
                  onChange={(e) => setLocal({ ...local, ma2Period: Number(e.target.value) })}
                  className="w-20 rounded px-2 py-1 text-center font-bold text-white"
                  style={{ background: '#0f1522', border: '1px solid #283652' }} />
              </div>
            )}
          </div>

          {/* RSI */}
          <div className="p-3.5 rounded-xl space-y-3"
            style={{ background: '#172030', border: '1px solid #222f47' }}>
            <label className="flex items-center space-x-2 cursor-pointer">
              <input type="checkbox" checked={local.rsiActive}
                onChange={(e) => setLocal({ ...local, rsiActive: e.target.checked })}
                className="w-4 h-4 rounded" />
              <span className="font-bold text-sm" style={{ color: '#e2e8f0' }}>Relative Strength Index (RSI)</span>
            </label>
            {local.rsiActive && (
              <div className="flex items-center justify-between text-xs" style={{ color: '#cbd5e1' }}>
                <span>RSI Period:</span>
                <input type="number" min={2} max={50} value={local.rsiPeriod}
                  onChange={(e) => setLocal({ ...local, rsiPeriod: Number(e.target.value) })}
                  className="w-20 rounded px-2 py-1 text-center font-bold text-white"
                  style={{ background: '#0f1522', border: '1px solid #283652' }} />
              </div>
            )}
          </div>

          {/* MACD */}
          <div className="p-3.5 rounded-xl space-y-3"
            style={{ background: '#172030', border: '1px solid #222f47' }}>
            <label className="flex items-center space-x-2 cursor-pointer">
              <input type="checkbox" checked={local.macdActive}
                onChange={(e) => setLocal({ ...local, macdActive: e.target.checked })}
                className="w-4 h-4 rounded" />
              <span className="font-bold text-sm" style={{ color: '#e2e8f0' }}>MACD Indicator Pane</span>
            </label>
            {local.macdActive && (
              <div className="grid grid-cols-3 gap-2 text-xs pt-1" style={{ color: '#cbd5e1' }}>
                <div>
                  <span className="block text-[10px]" style={{ color: '#94a3b8' }}>Fast (12):</span>
                  <input type="number" value={local.macdFast}
                    onChange={(e) => setLocal({ ...local, macdFast: Number(e.target.value) })}
                    className="w-full rounded px-2 py-1 text-center font-bold text-white"
                    style={{ background: '#0f1522', border: '1px solid #283652' }} />
                </div>
                <div>
                  <span className="block text-[10px]" style={{ color: '#94a3b8' }}>Slow (26):</span>
                  <input type="number" value={local.macdSlow}
                    onChange={(e) => setLocal({ ...local, macdSlow: Number(e.target.value) })}
                    className="w-full rounded px-2 py-1 text-center font-bold text-white"
                    style={{ background: '#0f1522', border: '1px solid #283652' }} />
                </div>
                <div>
                  <span className="block text-[10px]" style={{ color: '#94a3b8' }}>Signal (9):</span>
                  <input type="number" value={local.macdSignal}
                    onChange={(e) => setLocal({ ...local, macdSignal: Number(e.target.value) })}
                    className="w-full rounded px-2 py-1 text-center font-bold text-white"
                    style={{ background: '#0f1522', border: '1px solid #283652' }} />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 flex justify-end space-x-3"
          style={{ background: '#0f141e', borderTop: '1px solid #1f2a3e' }}>
          <button onClick={onClose}
            className="px-4 py-2 rounded-xl text-xs font-bold" style={{ color: '#94a3b8' }}>
            Cancel
          </button>
          <button onClick={handleSave}
            className="px-5 py-2 rounded-xl text-xs font-bold flex items-center space-x-1.5 shadow-lg"
            style={{ background: '#f59e0b', color: 'black', boxShadow: '0 10px 15px -3px rgba(245,158,11,0.2)' }}>
            <Check className="w-4 h-4" />
            <span>Apply Indicators</span>
          </button>
        </div>
      </div>
    </div>
  );
}
